export default __webpack_public_path__ + "static/media/pattern.01660e2f.png";